import React from 'react';
import { observer } from 'mobx-react';
import { PropTypes } from 'prop-types';
import C3Chart from 'react-c3js';
import 'c3/c3.css';

@observer
export default class C3GaugeChart extends React.Component {
  render() {
    const {
      completeness,
      title,
      intl,
      color,
      size,
      transition,
      hideTitle,
    } = this.props;

    const data = {
      columns: [[title, completeness]],
      type: 'gauge'
    };

    return (
      <div style={{ marginBottom: '15px', textAlign: 'center' }}>
        <C3Chart
          data={data}
          color={color}
          size={size}
          transition={transition}
        />
        {!hideTitle && <div className="text-center">{title}</div>}
      </div>
    );
  }
}

C3GaugeChart.defaultProps = {
  title: '',
  hideTitle: false,
  color: {
    pattern: ['#bbe1de', '#82cdc7', '#48b9b0', '#0fa69a'], // the three color levels for the percentage values.
    threshold: {
      values: [25, 50, 75, 100]
    }
  },
  size: { height: 90, width: 300 },
  transition: { duration: 500 }
};

C3GaugeChart.propTypes = {
  completeness: PropTypes.number.isRequired,
  title: PropTypes.string,
  hideTitle: PropTypes.bool,
  color: PropTypes.object,
  size: PropTypes.object,
  transition: PropTypes.object
};
